module.exports = __webpack_public_path__ + "assets/img/rs-levels.4d12fbe0.svg";